// extracted by mini-css-extract-plugin
export default {"title":"Intro_title__pvndS","richtext":"Intro_richtext__fVLmu"};